import { api } from "../base";
import type { IUpdateCustomerCreditLimitRequest } from "@pulse-ui/codegen-v2/generated_ts/venues/talos";
import type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";

export type { IUpdateCustomerCreditLimitRequest } from "@pulse-ui/codegen-v2/generated_ts/venues/talos";
export type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";

const customerCreditLimitEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    updateCustomerCreditLimit: build.mutation<
      IPulseApiResponse,
      IUpdateCustomerCreditLimitRequest
    >({
      query: (body) => ({
        url: "/api/trading-ops/v1/customer-credit-limits",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useUpdateCustomerCreditLimitMutation,
} = customerCreditLimitEndpoints;
